import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormStepWrapper } from "src/components";
import { selectTrack } from "src/store/projectSelectors";
import { AboveCard } from ".";
import DataCollectionQuestions from "./DataCollectionQuestions";
import GuidanceModal from "./GuidanceModal";
import Question from "./Question";
import {
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CTabs,
} from "@coreui/react";

const TABS = [{ key: "survey", label: "Impact Survey" }];

const SurveyStep = ({
  area,
  onChange,
  values,
  errors,
  orgName,
  isExternal,
  respondentId,
}) => {
  const { label, key: areaKey, questions } = area;
  const track = useSelector(selectTrack);
  // const track="self-assessment"

  let tabs = TABS;
  if (track === "validation") {
    tabs = [...TABS, { key: "data-collection", label: "Data Collection" }];
  }

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  const [guidanceToDisplay, setGuidanceToDisplay] = useState("");
  const closeModal = () => setGuidanceToDisplay("");

  return (
    <>
      <FormStepWrapper
        showTop={false}
        showReportingPeriod={false}
        showMenuButton={true}
        aboveCardSlot={<AboveCard />}
      >
        <p
          style={{ fontSize: "28px" }}
          className="font-bold text-center mb-0 text-info"
        >
          {label}
        </p>
        <CTabs activeTab={"survey"}>
          {track === "validation" && (
            <CNav
              className=" d-flex mt-4 justify-content-center w-100 border-bottom"
              variant="pills"
            >
              {tabs.map((tab, index) => {
                return (
                  <CNavItem key={tab.key}>
                    <CNavLink data-tab={tab.key}>{tab.label}</CNavLink>
                  </CNavItem>
                );
              })}
            </CNav>
          )}
          <CTabContent className="w-100 pt-4 d-flex flex-column align-items-center">
            <CTabPane data-tab="survey">
              {questions.map((q, idx) => (
                <Question
                  key={idx}
                  area={areaKey}
                  idx={idx}
                  values={values}
                  onChange={onChange}
                  errors={errors}
                  q={q}
                  respondentId={respondentId}
                  isExternal={isExternal}
                  orgName={orgName}
                  handleGuidance={() => setGuidanceToDisplay(q.guidance)}
                />
              ))}
            </CTabPane>
            <CTabPane className="w-100" data-tab="data-collection">
              {track === "validation" && (
                <DataCollectionQuestions
                  onChange={onChange}
                  values={values}
                  errors={errors}
                  area={areaKey}
                />
              )}
            </CTabPane>
          </CTabContent>
        </CTabs>
      </FormStepWrapper>
      <GuidanceModal
        show={!!guidanceToDisplay}
        closeModal={closeModal}
        guidance={guidanceToDisplay}
      />
    </>
  );
};
export default SurveyStep;
